export enum ApplyFee {
    LATER = 'LATER',
    NOW = 'NOW',
    WAIVE = 'WAIVE'
}
